import Vue from "vue";

/** Eine gemeinsame, sekündlich tickende Uhr für Countdown-Anzeigen (statt eines Timers je Karte) */
export const clock = Vue.observable({ now: Date.now() });
setInterval(() => {
  clock.now = Date.now();
}, 1000);
